export const isRegExp = (p: unknown): p is RegExp => {
  return (p as RegExp).test !== undefined;
};
